export const environment = {
  production: false,
  domain: 'ainstitute.cloud',
  cloudApiUrl: 'https://api.ainstitute.cloud',
  environmentMode: 'dev',
  erpSecretKey: '5930300f-68f8d622-65186c91-097311d1-506645fb-474abe11-4e5023d0-4dd4e925-aa22f584-207cc032-1695cc6e-758fb458-4e28a7d6-9d75e8b6-d920303d-d5ea2428'
};
